import { render, staticRenderFns } from "./PlanChangeComponent.vue?vue&type=template&id=572db9b6&scoped=true&"
import script from "./PlanChangeComponent.vue?vue&type=script&lang=js&"
export * from "./PlanChangeComponent.vue?vue&type=script&lang=js&"
import style0 from "./PlanChangeComponent.vue?vue&type=style&index=0&id=572db9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572db9b6",
  null
  
)

export default component.exports